import React, { Component } from "react";

import { Link} from "react-router-dom";

import { JENIS_DESA } from "../../../function/Koneksi";

// Import custom components
// import UserPanel from "./user-panel.component";

// koneksi
// import { STATUS_LAYANAN_KUA, STATUS_LAYANAN_CAPIL, GetMarketplace, ID_DESA } from "../../../function/Koneksi";

class SidebarEnumerator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paid: this.props.paid,
      lisensi: this.props.lisensi,
    };
  }

  cekStatus(){
    if (this.state.lisensi == null || this.state.paid == null) {
      return '/admin/layanan/join-us'
    } else if (this.state.paid && this.state.lisensi) {
      return true
    } else if (this.state.paid && this.state.lisensi == false) {
      return '/admin/layanan/expired'
    }
  }

  render() {
    return (
      <div className="bayu-sidebar custom-scrollbar bayu-sidebar-open">
        <ul className="sidebar-menu">
          <div className="dropdown-basic">
            <div className="row">
              <div className="dropdown">
                <Link to={process.env.PUBLIC_URL}>
                  <div className="btn-group m-1">
                    <button
                      type="button"
                      className="dropbtn btn-primary-custom"
                      style={{ borderRadius: "10px", width: "155px" }}
                    >
                      <i className="fa fa-home"></i> Dashboard
                    </button>
                  </div>
                </Link>
              </div>
              <div className="dropdown">
                <div className="btn-group m-1">
                  <button
                    type="button"
                    className="dropbtn btn-primary-custom"
                    style={{ borderRadius: "10px"}}
                  >
                    <i className="icofont icofont-users-alt-4"></i> Kependudukan
                    <span>
                      <i className="icofont icofont-arrow-down"></i>
                    </span>
                  </button>
                  <div className="dropdown-content">
                    <Link to={ 
                      this.cekStatus ? "/admin/penduduk" : this.cekStatus
                      }>
                      <i className="fa fa-user"></i> Penduduk
                    </Link>
                    <Link to={ 
                      this.cekStatus ? "/admin/kartu-keluarga" : this.cekStatus
                      }>
                      <i className="fa fa-users"></i> Kartu Keluarga
                    </Link>
                    {
                      localStorage.getItem('JENIS_APLIKASI').toLowerCase() === "amanat nagari"
                      ?
                      <>
                        <Link to={ 
                          this.cekStatus ? "/admin/suku" : this.cekStatus
                          }>
                          <i className="fa fa-users"></i> Suku
                        </Link>
                        <Link to={ 
                          this.cekStatus ? "/admin/datuak" : this.cekStatus
                          }>
                          <i className="fa fa-users"></i> Datuak
                        </Link>
                        <Link to={ 
                          this.cekStatus ? "/admin/penduduksuku" : this.cekStatus
                          }>
                          <i className="fa fa-users"></i> Penduduk Suku
                        </Link>
                      </>
                      :
                      <>
                      </>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ul>
      </div>
    );
  }
}

export default SidebarEnumerator;
